"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterSchema = createFilterSchema;
const types_1 = require("./types");
function createFilterSchema(schema, options) {
    const reservedColumns = new Set(options?.reservedColumns ?? types_1.DEFAULT_RESERVED_COLUMNS);
    for (const [fieldName, fieldDef] of Object.entries(schema.fields)) {
        if (!types_1.VALID_FIELD_NAME_PATTERN.test(fieldName)) {
            throw new Error(`Invalid field name "${fieldName}" in filter schema. ` +
                `Field names must match ${types_1.VALID_FIELD_NAME_PATTERN.toString()}.`);
        }
        const resolvedColumns = getResolvedColumns(fieldName, fieldDef);
        for (const col of resolvedColumns) {
            if (reservedColumns.has(col)) {
                throw new Error(`Field "${fieldName}" maps to reserved column "${col}". ` +
                    `Tenancy columns must not be exposed as filterable fields.`);
            }
            if (!types_1.VALID_FIELD_NAME_PATTERN.test(col)) {
                throw new Error(`Field "${fieldName}" references invalid column name "${col}". ` +
                    `Column names must match ${types_1.VALID_FIELD_NAME_PATTERN.toString()}.`);
            }
        }
    }
    return { ...schema, __validated: true };
}
function getResolvedColumns(fieldName, fieldDef) {
    const { options } = fieldDef;
    switch (options.type) {
        case types_1.FieldType.String:
        case types_1.FieldType.Boolean:
        case types_1.FieldType.Number:
        case types_1.FieldType.Date: {
            return [options.column ?? fieldName];
        }
        case types_1.FieldType.Relation: {
            return [options.relation, ...options.searchColumns];
        }
        case types_1.FieldType.Custom: {
            return [];
        }
    }
}
//# sourceMappingURL=filter-schema.js.map